export default {
  cliente: "Client",
  equipo: "Equipment",
  problema: "Issue",
  accesorios: "Accessories",
  agendado: "Scheduled",
  fecha: "Date",
  tecnico: "Technician",
  estado: "Status",
  tipo: "Type",
  grado: "Severity",
  sucursal: "Branch",
  motivo: "Reason",
  documento: "Document",
  direccion: "Address",
  telefono: "Phone",
  email: "Email",
  celular: "Mobile",
  nombre: "Name",
  sucursalCliente: "Client branch",
  localidad: "City",
  estadoDepto: "State",
  pais: "Country",
  contacto: "Contact",
  codigo: "Code",
  nroParte: "Part number",
  codBarras: "Barcode",
  descripcion: "Description",
  costo: "Cost",
  precio: "Price",
  moneda: "Currency",
  proveedor: "Supplier",
  marca: "Brand",
  stock: "Stock",
  total: "Total",
  usuario: "User",
  guia: "Guide",
  origen: "Origin",
  destino: "Destination",
  familia: "Family",
  numSerie: "Serial number",
  tipoEquipo: "Equipment type",
  modelo: "Model",
  orden: "Order",
  enviado: "Date sent",
  recibido: "Date received",
  nroExpediente: "Case number",
  rubro: "Sector",
  vencimiento: "Expiration",
  tipoTecnico: "Technician type",
  nota: "Note",
  repuesto: "Spare part",
  informe: "Customer report",
  depto: "Department/Area",
  falla: "Failure"
}
